var _path, _path2, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 62.5",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.116,16.841c3.15-5.553,2.938-12.074,2.938-12.074c-2.596,6.343-10.151,9.952-10.151,9.952  c0.886-5.545,4.639-9.412,4.639-9.412c-9.872,3.558-14.746,9.935-15.88,12.479c0.283-2.846,1.058-6.272,0.931-8.854  c0,0-4.975,4.905-8.396,7.788c-3.423,2.883-12.364,12.19-8.143,22.034c3.386,7.897,17.081,9.844,25.14-1.386  c4.572-6.374,11.348-14.189,11.431-17.125c0,0-4.941,3.778-9.9,4.563C33.723,24.806,37.529,23.163,41.116,16.841z M26.953,38.702  c-2.981,3.145-6.488,5.092-10.178,5.092c-3.808,0-7.124-2.002-8.454-5.102c-1.578-3.684-0.317-8.563,1.186-10.949  c2.672-4.238,5.844-6.622,8.422-7.581c0,0-0.94,3.563-1.161,6.604c0,0,7.629-2.537,10.329-5.111c0,0-0.694,6.018-3.355,9.33  c0,0,4.225-0.633,6.854-1.841C30.595,29.145,30.595,34.859,26.953,38.702z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.03,32.349c-1.825-1.283-3.9-1.804-6.096-1.072c-1.897,0.63-3.246,1.453-3.682,2.68  c-0.474,1.336,0.568,6.314,4.051,7.427c2.991,0.956,7.518-2.2,8.425-5.049C23.174,34.938,21.856,33.631,20.03,32.349z   M13.943,35.688c-0.607,0-1.099-0.492-1.099-1.099c0-0.608,0.491-1.101,1.099-1.101s1.101,0.492,1.101,1.101  C15.044,35.195,14.551,35.688,13.943,35.688z M15.9,40.132c-0.776,0-1.403-0.628-1.403-1.403c0-0.776,0.627-1.405,1.403-1.405  c0.775,0,1.405,0.629,1.405,1.405C17.306,39.504,16.676,40.132,15.9,40.132z M18.903,36.262c-0.463,0-0.836-0.374-0.836-0.836  s0.373-0.837,0.836-0.837s0.837,0.375,0.837,0.837S19.366,36.262,18.903,36.262z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Pinky")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d16c7834a922b98f4fc1e5ce3e5530a2.svg";
export { ForwardRef as ReactComponent };